/**
 * Nombre de la app, en un solo lugar.
 *
 * Para renombrarla se edita `src/brand.json` y se corre `npm run build`: el
 * prebuild (`scripts/sync-brand.mjs`) lo copia a los archivos que no pueden
 * importar TypeScript (index.html, manifest, capacitor.config.ts y el
 * strings.xml de Android). En la app se usa APP_NAME o <app-brand-logo>.
 *
 * Es solo el nombre visible: el appId de Android, la base de datos local y
 * las rutas del servidor siguen con su nombre técnico a propósito.
 */
import brand from '../../brand.json';

export const APP_NAME: string = brand.name;
export const APP_SHORT_NAME: string = brand.shortName;

/** Primera palabra (va resaltada en el logo) y el resto del nombre. */
export function splitBrandName(name: string = APP_NAME): [string, string] {
  const [lead, ...rest] = name.trim().split(/\s+/);
  return [lead ?? '', rest.join(' ')];
}
